import React, { useEffect, useState } from 'react';
import checkIcon from '../../../../../assets/image/check_stock_icon.svg';
import useAccounts from './hooks/useAccounts';
import CreateAccountsModal from '../components/createAccountsModal';
import PageLoader from '../../../../../component/PageLoader';
import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';
import DataNotFound from '../../../../components/dataNotFound';
import Pagination from '../../../../../component/pagination';
import AccountsDetails from './accountsDetails';
import AccountListTable from '../components/accountListTable';
import CustomToastMessage from '../../../../components/customToastMessage';
import DeleteAccountModel from '../components/deleteAccountModel';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import AccountsDropdownComponent from '../components/accountsDropdownComponent';
import SearchAccountsComponent from '../components/searchAccountsComponent';
import { useLocation } from 'react-router-dom';
import ActivateAccountModal from '../components/activateAccountModal';
import DeactivateAccountReasonModal from '../components/deactivateAccountReasonModal';
import RecentTransaction from './recentTransaction';

export default function Accounts({ activeTab }) {
	const {
		setIsOpenAccountsModal,
		isOpenAccountsModal,
		params,
		setParams,
		setSearchText,
		searchText,
		sortDataList,
		sortDirection,
		setLoader,
		loader,
		accounts,
		isShowToast,
		showMessage,
		setIsOpenDeactivateConfirmAccountModal,
		isOpenDeactivateConfirmAccountModal,
		setIsOpenDeactivateAccountModal,
		isOpenDeactivateAccountModal,
		setIsOpenActivateAccountModal,
		isOpenActivateAccountModal,
		getAccountList,
	} = useAccounts();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [type, setType] = useState('account-list');
	const [selectedAccountId, setSelectedAccountId] = useState(null);
	const onRowClick = (id) => {
		if (id && hasPermission('settings.accounts.view', user?.role?.role_permissions)) {
			setSelectedAccountId(id);
			setType('account-details');
		}
	};
	const [isAccountOpenDropdown, setIsAccountOpenDropdown] = useState(false);
	const [isOpenDeleteAccountModal, setIsOpenDeleteAccountModal] = useState(false);
	const [isActivateAccountModal, setIsActivateAccountModal] = useState(false);
	const location = useLocation();
	const toggle = () => {
		setIsAccountOpenDropdown(!isAccountOpenDropdown);
	};

	const columns = [
		{ key: 'account_name', label: 'ACCOUNT NAME' },
		{ key: 'account_code', label: 'ACCOUNT CODE' },
		{ key: 'account_type', label: 'ACCOUNT TYPE' },
		{ key: 'category', label: 'CATEGORY' },
		{ key: 'description', label: 'USED FOR' },
		{ key: 'status', label: 'STATUS' },
		{ key: 'source', label: 'SOURCE' },
		{ key: 'action', label: 'ACTION' },
	];

	const changeAccountRoute = () => {
		if (location.state && location.state.id) {
			setSelectedAccountId(location.state.id);
			setType('account-details');
		}
	};

	useEffect(() => {
		changeAccountRoute();
	}, []);

	return (
		<div>
			{type === 'account-list' ? (
				<div>
					<SettingHeaderComponent
						title={activeTab}
						subtitle={
							'Manage accounts used for recording sales, purchases, payments, expenses, stock, and other business transactions.'
						}
						buttons={[
							{
								id: 1,
								disabled: false,
								className: 'btn-primary',
								add: true,
								close: false,
								dataTestId: 'create-account-button',
								button: 'New Accounts',
								handler: () => {
									setSelectedAccountId(null);
									setIsOpenAccountsModal(true);
								},
							},
							{
								id: 2,
								disabled: false,
								className: 'btn-gray',
								add: false,
								close: false,
								dataTestId: 'account-export-button',
								button: 'Import Accounts',
								handler: () => { },
							},
						]}
					/>
					<div className="d-flex px-3 py-4 gap-4">
						<AccountsDropdownComponent
							params={params}
							toggle={toggle}
							isAccountOpenDropdown={isAccountOpenDropdown}
							setParams={setParams}
						/>
						<SearchAccountsComponent
							searchText={searchText}
							setSearchText={setSearchText}
						/>
					</div>
					{loader ? (
						<PageLoader />
					) : accounts.data.length > 0 ? (
						<div className="productTable-body">
							<AccountListTable
								columns={columns}
								accountType={'accounts'}
								row={accounts.data}
								sortDataList={sortDataList}
								onRowClick={onRowClick}
								setAccountId={setSelectedAccountId}
								sortDirection={sortDirection}
								setIsOpenAccountsModal={setIsOpenAccountsModal}
								setIsOpenDeactivateConfirmAccountModal={setIsOpenDeactivateConfirmAccountModal}
								setIsOpenDeleteModal={setIsOpenDeleteAccountModal}
								setIsOpenActivateAccountModal={setIsActivateAccountModal}
							/>
						</div>
					) : (
						<DataNotFound
							title={'No custom accounts added yet!'}
							subtitle={'Add a custom account only when you want to track'}
							content={'something separately.'}
							descriptionTitle={''}
							descriptionSubTitle={''}
							descriptionContent={''}
							buttonText={'Add New Account'}
							disabled={!hasPermission('settings.accounts.create', user?.role?.role_permissions)}
							onClick={() => setIsOpenAccountsModal(true)}
						/>
					)}
					{accounts.data.length > 0 && (
						<Pagination
							PageFix={1}
							currentPage={params.page}
							totalPages={accounts.totalPages}
							onChangePage={(page) => {
								setParams((prev) => ({
									...prev,
									page: page,
								}));
							}}
							pageSize={params.page_size}
							setParam={(value) => {
								setParams((prev) => ({
									...prev,
									page_size: value,
									page: 1,
								}));
							}}
						/>
					)}
				</div>
			) : type === 'account-details' ? (
				<AccountsDetails
					setIsOpenAccountsModal={setIsOpenAccountsModal}
					accountId={selectedAccountId}
					setAccountId={setSelectedAccountId}
					setType={setType}
					type={type}
					setLoader={setLoader}
					loader={loader}
					setIsOpenActivateAccountModal={setIsOpenActivateAccountModal}
					setIsOpenDeactivateAccountModal={setIsOpenDeactivateAccountModal}
					isOpenDeactivateAccountModal={isOpenDeactivateAccountModal}
					isOpenActivateAccountModal={isOpenActivateAccountModal}
					showMessage={showMessage}
					isOpenAccountsModal={isOpenAccountsModal}
					getAccountList={getAccountList}
				/>
			) : type === 'recent-transaction' ? (
				<RecentTransaction
					setLoader={setLoader}
					loader={loader}
					accountId={selectedAccountId}
					setType={setType}
					type={type}
				/>
			) : (
				<></>
			)}

			{isOpenAccountsModal && (
				<CreateAccountsModal
					showMessage={showMessage}
					setSelectedId={setSelectedAccountId}
					selectedId={selectedAccountId}
					isOpenModal={isOpenAccountsModal}
					setIsOpenModal={setIsOpenAccountsModal}
					getList={getAccountList}
				/>
			)}

			{isShowToast && (
				<CustomToastMessage
					icon={checkIcon}
					title={
						selectedAccountId ? 'Account updated successfully' : 'Account created successfully'
					}
					description={
						selectedAccountId
							? 'All changes have been saved and are now reflected in the system.'
							: 'Your account has been created. You can now use it to record and track transactions.'
					}
				/>
			)}

			{isOpenDeleteAccountModal && (
				<DeleteAccountModel
					isOpenModal={isOpenDeleteAccountModal}
					setIsOpenModal={setIsOpenDeleteAccountModal}
					accountId={selectedAccountId}
					getList={getAccountList}
				/>
			)}

			{isActivateAccountModal && (
				<ActivateAccountModal
					accountId={selectedAccountId}
					isOpenModal={isActivateAccountModal}
					setIsOpenModal={setIsActivateAccountModal}
					getAccountDetails={getAccountList}
				/>
			)}
			{isOpenDeactivateConfirmAccountModal && (
				<DeactivateAccountReasonModal
					isOpenModal={isOpenDeactivateConfirmAccountModal}
					setIsOpenModal={setIsOpenDeactivateConfirmAccountModal}
					accountId={selectedAccountId}
					getAccountDetails={getAccountList}
				/>
			)}

		</div>
	);
}
